import airportData from 'aircodes';
import { FieldValues } from 'react-hook-form';

import {
  AutocompleteFormField,
  AutocompleteFormFieldProps,
} from '@/components/shared/components/NewContextForms/AutocompleteFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

type OptionObject = {
  iata: string;
  icao: string;
  name: string;
  city: string;
  state: string;
  country: string;
};

export interface AirportFieldProps<TFieldValues extends FieldValues, TOptionObject extends object | null | undefined>
  extends Omit<AutocompleteFormFieldProps<TFieldValues, TOptionObject>, 'displayFn' | 'findFn' | 'initialValueFn'> {
  exclude?: OptionObject;
}

export const AirportField = <TFieldValues extends FieldValues>({
  name,
  exclude,
  ...props
}: AirportFieldProps<TFieldValues, OptionObject>) => {
  const airportDisplayFn = (option) => {
    if (typeof option !== 'object') return '';
    return `${option.name} (${option.iata})`;
  };

  const airportFindFn = (searchValue) =>
    exclude?.iata
      ? airportData.findAirport(searchValue).filter((option) => option.iata !== exclude.iata)
      : airportData.findAirport(searchValue);

  const airportInitialValueFn = (selectedOption) => airportData.getAirportByIata(selectedOption?.iata) || null;

  return (
    <AutocompleteFormField
      name={name}
      displayFn={airportDisplayFn}
      findFn={airportFindFn}
      initialValueFn={airportInitialValueFn}
      {...props}
      fieldVariant={FieldVariant.form}
      searchValueMinLength={2}
    />
  );
};
